<template>
    <div>
        <mmModal ref="modalAuthenticator" size="md" :title="$t('validateCode')">
            <div>
                <p>{{ $t('enterCode') }}</p>
                <div class="form-group">
                    <label>{{ $t('code') }}</label>
                    <input type="text" name="codeAuthenticator" v-model="code" class="form-control" />
                </div>
            </div>
            <template #buttons>
                <a href="#" @click.prevent="clickModal" class="btn btn-primary">{{ $t('save') }}</a>
            </template>
        </mmModal>
    </div>
</template>

<script>
    import mmModal from '@mysummar/summar-vue/src/components/mmModal.vue'

    export default {
        name: 'ModalAuthenticator',
        components: {
            mmModal
        },
        data() {
            return {
                code: '',
                values: {}
            }
        },
        methods: {
            openModal(v)
            {
                if(v!=undefined) this.values = v;
                this.code = '';
                this.$refs.modalAuthenticator.show();
            },
            clickModal()
            {
                this.$emit('getCode', { ...{code: this.code}, ...this.values });
                this.$refs.modalAuthenticator.hide();
            }
        }
    }
</script>